import React from "react";
import { TenantListContextProvider } from "./TenantListView";
import TenantList from "./views/TenantList";

const TenantListPage = () => {
  return (
    <TenantListContextProvider>
      <TenantList />
    </TenantListContextProvider>
  );
};

export default TenantListPage;
